import React from 'react';
import { useSelector } from 'react-redux';

import PackageColumnWrapper from '../../../components/columns/package-column';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const PackageColumnComponent = ({ fulfillmentId }) => {
  const ret = useSelector((state) => Global.selectEntitiesReturnById(state, { fulfillmentId }));
  if (!ret) {
    return '';
  }

  const { returnConfiguration } = ret || {};
  const { packages } = returnConfiguration || {};
  const firstPackage = packages && packages.length > 0 ? packages[0] : null;
  const { packageTypeId } = firstPackage || {};

  if (!packageTypeId) {
    return '';
  }

  return <PackageColumnWrapper packageTypeId={packageTypeId} />;
};

export const PackageColumn = {
  getMessageDescriptor: () => messages.packageText,
  id: 'package',

  render: ({ fulfillmentId }) => {
    return <PackageColumnComponent fulfillmentId={fulfillmentId} />;
  },
};
